//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const SubscriptionUserLevels = Object.freeze([40, 41, 42, 50, 51, 52])

export default {
  name: 'AccountDropdown',
  data() {
    return {
      isOpen: false,
      showLogin: true,
      showForgotPassword: false,
      waitingForPin: false,
      confirmationEmail: null,
      password: null,
      isDownload: false,
      priceId: null
    }
  },
  computed: {
    account() {
      return this.$store.get('user/user') || null
    },
    subscriptionUserLevels() {
      if (!this.account || !this.account.userLevels) return []
      return this.account.userLevels.filter((x) => SubscriptionUserLevels.includes(x.levelId))
    },
    remainingCount() {
      return this.$store.get('navbar/remainingToRead') || null
    },
    cartItems() {
      return this.$store.get('cart/items') || null
    },
    cartTotal() {
      return this.cartItems.map((x) => x.quantity).reduce((a, b) => a + b, 0)
    },
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    }
  },
  watch: {
    async account(value) {
      if (value) {
        await this.onUserLoggedIn()
      }
    }
  },
  beforeDestroy() {
    this.$nuxt.$off('remaining-count')
    this.$nuxt.$off('openingCart')
    this.$nuxt.$off('toggleRegisterModal')
  },
  mounted() {
    this.$nuxt.$on('remaining-count', (val) => {
      this.$store.set('navbar/remainingToRead', val)
    })
    this.$nuxt.$on('openingCart', (isOpen) => {
      this.$refs.cartMenu.toggle(isOpen)
    })
    this.$nuxt.$on('toggleRegisterModal', (options) => {
      this.$refs.dropdown.toggle()
      this.showLogin = false
      this.waitingForPin = false

      this.isDownload = options ? options.isDownload : false
    })
    this.$nuxt.$on('registerAndCheckout', (value) => {
      setTimeout(() => {
        this.openRegister()
        this.priceId = value
      }, 1)
    })
    setTimeout(() => {
      if ('new-password' in this.$route.query) {
        this.openForgotPassword()
      }
    }, 1)
  },
  methods: {
    openForgotPassword() {
      this.onForgotPasswordClicked()
      this.onActiveChange(true)
    },
    openRegister() {
      this.onRegisterClicked()
      this.onActiveChange(true)
    },
    onActiveChange(active) {
      if (this.$refs.dropdown) {
        this.$refs.dropdown.isActive = active
      }
      this.isOpen = active

      this.$nuxt.$emit('isAccountDropdownOpen', this.isOpen)

      if (!active) {
        this.priceId = null
      }
    },
    close() {
      if (this.isOpen) {
        this.$refs.dropdown.toggle()
        this.priceId = null
      }
    },
    async onUserLoggedIn() {
      if (this.priceId) {
        await this.createCheckout()
      }
      this.close()
      this.showLogin = true
      this.waitingForPin = false
      this.isOpen = false

      if (this.isDownload) {
        this.$nuxt.$emit('startDownload')
      }
    },
    onLoginClicked() {
      this.showLogin = true
      this.showForgotPassword = false
    },
    onRegisterClicked() {
      this.showLogin = false
    },
    onForgotPasswordClicked() {
      this.showLogin = false
      this.showForgotPassword = true
    },
    onUserConfirmed() {
      this.showLogin = false
      this.needToRegister = false

      if (this.isDownload) {
        this.$nuxt.$emit('startDownload')
      }
    },
    onUserRegistered(result) {
      this.confirmationEmail = result.email
      this.password = result.password
      this.waitingForPin = true
    },
    onLogoutClick() {
      this.close()
      setTimeout(() => {
        this.$auth.logout()
        this.$store.set('cart/items', [])
        if (this.$route.path !== '/') this.$router.replace({ path: '/' })
      }, 300)
    },
    async createCheckout() {
      const { url } = await this.$axios.$post(`${this.$config.apiRestUrl}/order/create-subscription-checkout-session`, {
        successUrl: `${this.$config.baseURL}/`,
        cancelUrl: `${this.$config.baseURL}/subscriptions`,
        priceId: this.priceId
      })
      window.location.replace(url)
    }
  }
}
